var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invitation" }, [
    _vm.istanchaung ? _c("div", { staticClass: "zhezhao" }) : _vm._e(),
    _vm._v(" "),
    _vm.istanchaung
      ? _c("div", { staticClass: "Popup" }, [
          _c("div", { staticClass: "shang" }, [
            _c("img", { attrs: { src: "/static/img/tijiao.png", alt: "" } }),
            _vm._v(" "),
            _c("img", {
              staticClass: "xs",
              attrs: { src: "/static/img/assets/chahao.png", alt: "" },
              on: { click: _vm.hidden }
            })
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "xia" }, [
            _c("button", { on: { click: _vm.gohome } }, [_vm._v("立即访问")])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("img", { attrs: { src: "/static/img/beijing.png", alt: "" } }),
    _vm._v(" "),
    _c("div", { staticClass: "centent" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "inv-title" }, [
        _c("p", [_vm._v(_vm._s(_vm.enterprise.username))]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "inv-text" }, [_vm._v("邀请您加入")]),
          _vm._v(" "),
          _c("span", { staticClass: "inv-text" }, [
            _vm._v(_vm._s(_vm.enterprise.companyName))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("input", {
        ref: "phone",
        staticClass: "padding-left",
        attrs: { type: "text", placeholder: "请输入手机号" },
        on: { blur: _vm.phone }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "Verification" }, [
        _c("input", {
          ref: "Verification",
          staticClass: "padding-left",
          attrs: { type: "text", placeholder: "请输入验证码" },
          on: { change: _vm.validCode }
        }),
        _vm._v(" "),
        _vm.isobtaincode
          ? _c("span", { staticClass: "xs", on: { click: _vm.Obtaincode } }, [
              _vm._v("获取验证码")
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isobtaincode
          ? _c("span", { ref: "obtaincode" }, [_vm._v(_vm._s(_vm.time))])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("input", {
        ref: "name",
        staticClass: "padding-left",
        attrs: { type: "text", placeholder: "请输入姓名" },
        on: { blur: _vm.name }
      }),
      _vm._v(" "),
      _c("button", { staticClass: "login", on: { click: _vm.login } }, [
        _vm._v("提交")
      ])
    ]),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "zhong" }, [
      _c("p", [_vm._v("欢迎你加入云系统，立即畅享轻松工作！")]),
      _vm._v(" "),
      _c("p", [_vm._v("新用户登录密码随后将发送短信通知请注意查收")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { width: "80px" },
        attrs: { src: "/static/img/assets/logo@2x.png", alt: "" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "inv-logo" }, [_vm._v("云系统")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("p", [_vm._v("云系统|电子行业企业管理云端解决方案")]),
      _vm._v(" "),
      _c("p", [_vm._v("深圳市华商数据科技有限公司")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a141dd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a141dd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/invitation.vue
// module id = null
// module chunks = 